export const NAV_WIDTH = {
  expanded: 250,
  collapsed: 44,
};

export const NEXT_NAV_WIDTH = {
  expanded: 252,
  collapsed: 44,
};

export const TOP_NAV_BAR_PROPS = {
  height: 45,
  borderColor: "#d8dfea",
};

export const TEMP_TOP_NAV_BAR_PROPS = {
  height: 44,
  borderColor: "#d8dfea",
};

export const NEXT_TOP_NAV_BAR_PROPS = {
  height: 43,
  borderColor: "#d8dfea",
};
